import http from "../utilities/http-common"

const validerJwt =  async (jwt,id) => {
	return http.get("/validerToken/"+jwt+"/"+id);
};
  
  export default {
    validerJwt

  };